import { useState, useEffect, useMemo } from 'react';
import { TextField, IconButton, Grid, MenuItem } from '@mui/material';
import { DeleteOutlineRounded } from '@mui/icons-material';
import { isFunction, isArray, isEmpty } from 'lodash';

const AGGREGATION_FUNCTIONS = [
  { value: 'sum', title: 'Sum' },
  { value: 'avg', title: 'Average' },
  { value: 'min', title: 'Minimum' },
  { value: 'max', title: 'Maximum' },
];

export default function SummaryItem({ initial, onChange, onDelete, numberColumns }) {
  const [columnId, setColumnId] = useState('');
  const [dataSetColumnId, setDataSetColumnId] = useState('');
  const [aggregationFunction, setAggregationFunction] = useState('');

  useEffect(() => {
    setColumnId(initial?.columnId || '');
    setDataSetColumnId(initial?.dataSetColumnId || '');
    setAggregationFunction(initial?.aggregationFunction || '');
  }, [initial]);

  const selectedDataSetNumberColumns = useMemo(() => {
    if (!columnId || !isArray(numberColumns)) return [];

    const selectedField = numberColumns.find((x) => x.id === columnId);

    if (selectedField?.fieldType !== 'dataSet' || !isArray(selectedField?.dataSetParams?.columns)) {
      return [];
    }
    const numberDataSetColumns = selectedField.dataSetParams.columns.filter((x) => x.type === 'number');
    return numberDataSetColumns;
  }, [columnId, numberColumns]);

  function sendResult(data) {
    if (!isFunction(onChange)) return;

    const result = {
      columnId,
      dataSetColumnId,
      aggregationFunction,
      ...data,
    };

    onChange(result);
  }

  return (
    <Grid container sx={{ py: 1 }} id={initial._id}>
      <Grid container alignItems="center" wrap="nowrap">
        <TextField
          label="Column"
          select
          variant="standard"
          sx={{ width: 180 }}
          value={columnId}
          required
          onChange={(e) => {
            setColumnId(e.target.value);
            setDataSetColumnId('');
            sendResult({ columnId: e.target.value, dataSetColumnId: '' });
          }}
        >
          {numberColumns.map((columns) => (
            <MenuItem value={columns.id} key={columns.id}>
              {columns.title}
            </MenuItem>
          ))}
        </TextField>

        {!isEmpty(selectedDataSetNumberColumns) && (
          <TextField
            label="Data set column"
            select
            variant="standard"
            sx={{ width: 160, ml: 1 }}
            required
            value={dataSetColumnId}
            onChange={(e) => {
              setDataSetColumnId(e.target.value);
              sendResult({ dataSetColumnId: e.target.value });
            }}
          >
            {selectedDataSetNumberColumns.map((columns) => (
              <MenuItem value={columns.id} key={columns.id}>
                {columns.title}
              </MenuItem>
            ))}
          </TextField>
        )}

        <TextField
          label="Function"
          select
          variant="standard"
          sx={{ width: 100, ml: 1 }}
          value={aggregationFunction}
          required
          onChange={(e) => {
            setAggregationFunction(e.target.value);
            sendResult({ aggregationFunction: e.target.value });
          }}
        >
          {AGGREGATION_FUNCTIONS.map((item) => (
            <MenuItem value={item.value} key={item.value}>
              {item.title}
            </MenuItem>
          ))}
        </TextField>

        <IconButton sx={{ ml: 'auto' }} onClick={onDelete}>
          <DeleteOutlineRounded color="error" />
        </IconButton>
      </Grid>
    </Grid>
  );
}
